import React from 'react'
import LoopIcon from '@mui/icons-material/Loop';
import IconButton from "@mui/material/IconButton";
import {Tooltip} from "@mui/material";
import {useTranslation} from "react-i18next";
const CurrentStateLoading = ( {onLoadingClick,size = 'small',loading = false}) => {

    const {t, i18n} = useTranslation();
    return(<React.Fragment>
        <Tooltip title={t('refresh')}>
            <IconButton color="info"
                        aria-label="loading"
                        data-test="refresh-btn"
                        size={size} sx={{
                '&:hover': {
                    transform: 'rotate(90deg)',
                },
                transition: 'transform 0.3s ease-in-out'
            }}
                        onClick={onLoadingClick}
                        disabled={loading}

            >
                <LoopIcon/>
            </IconButton>
        </Tooltip>
    </React.Fragment>)
}

export default CurrentStateLoading